module.exports = __webpack_public_path__ + "logo.c824bd59b30bbbb2c5aa.png";


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/assets/img/logo.png
// module id = ../../../../../src/assets/img/logo.png
// module chunks = styles